export const LOAD_REQUESTED = "ARRAY_FIELD_TEMPLATE/LOAD_REQUESTED";
export const LOAD_SUCCESS = "ARRAY_FIELD_TEMPLATE/LOAD_SUCCESS";
export const LOAD_FAIL = "ARRAY_FIELD_TEMPLATE/LOAD_FAIL";

export default (state = {}, { type }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadArrayFieldTemplate = data => ({ type: LOAD_REQUESTED, data });
export const successLoadArrayFieldTemplate = data => ({ type: LOAD_SUCCESS, data });
export const failLoadArrayFieldTemplate = data => ({ type: LOAD_FAIL, data });
